import { action, extendObservable } from 'mobx';
import FetchService from '../../../core/services/FetchService';

export default class CertificationTestExecutionListService {
  fetch = new FetchService();
  submit = new FetchService();
  download = new FetchService();

  constructor() {
    extendObservable(this, {
      certificationTests: [],
      filter: '',
      pagination: {
        current: 1,
        pageSize: 25,
        total: 0,
      },
      status: '',
    });
  }

  init = action((status) => {
    this.certificationTests = [];
    this.filter = '';
    this.pagination = {
      ...this.pagination,
      current: 1,
    };
    this.status = status;
    this.load();
  });

  load = action(() => {
    this.fetch
      .fetch({
        url: '/certification-test',
        query: {
          page: this.pagination.current,
          size: this.pagination.pageSize,
          query: {
            status: this.status,
            ...(this.filter && {
              name: {
                $regex: this.filter,
                $options: 'i',
              },
            }),
          },
        },
      })
      .then(() => {
        if (this.fetch.data) {
          this.certificationTests = this.fetch.data.docs;
          this.pagination = { ...this.pagination, total: this.fetch.data.total };
        } else {
          this.certificationTests = [];
          this.pagination = { ...this.pagination, current: 1, total: 0 };
        }
      });
  });

  handleFilterChange = action((value) => {
    this.filter = value;
    this.load();
  });

  handleChange = action((pagination, filters, sort) => {
    this.pagination = { ...this.pagination, ...pagination };
    this.sort = sort;
    this.load();
  });

  handleDownloadTemplate = action((certificationTest) => {
    this.download
      .fetch({
        responseType: 'blob',
        url: `/certification-test/${certificationTest.id}/certificate-template`,
      })
      .then(() => {
        if (this.download.data) {
          const link = document.createElement('a');
          const fileUrl = window.URL.createObjectURL(this.download.data);
          link.href = fileUrl;

          link.download = 'certificate_test_certificate.pdf';
          link.click();
          setTimeout(() => window.URL.revokeObjectURL(fileUrl), 500);
        }
      });
  });
}
